module.exports = __webpack_public_path__ + "static/media/Youtube.49ced784.svg";